//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'

import Footer from '@/components/Footer.vue'
import TopNav from '@/components/TopNav.vue'

import { DATE_FORMAT } from '@/lib/constants'
import { markdownToHTML } from '@/lib/converters'
import { formatDate } from '@/lib/utils'
import { MAGIC_UNLIMITED_NUMBER } from '@/lib/plans'

import announcements from '@/graphql/queries/announcements.gql'

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Default',
  components: {
    'postpone-footer': Footer,
    'postpone-topnav': TopNav
  },
  data() {
    return {
      DATE_FORMAT,
      firstDayOfNextMonth: new moment().add(1, 'months').date(1),
      announcements: [],
      callbacks: {
        onStart: this.onStart,
        onStop: this.onStop,
        onSkip: this.onSkip,
        onFinish: this.onFinish
      },
      steps: [
        {
          target: '[data-v-step="schedule"]',
          header: {
            title: 'Schedule Posts'
          },
          content:
            'Use the <strong>Schedule a Post</strong> button to schedule Reddit posts from anywhere in Postpone.',
          params: {
            placement: 'right',
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="dashboard"]',
          header: {
            title: 'Dashboard'
          },
          content:
            'This is the <strong>Dashboard</strong>. All of your scheduled posts are displayed here.',
          params: {
            placement: 'right',
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="submissions"]',
          header: {
            title: 'Submissions'
          },
          content:
            "After posts are submitted to Reddit they'll appear under <strong>Submissions</strong>. If posts fail to submit then they'll also be on this page.",
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="analytics"]',
          header: {
            title: 'Post Analytics'
          },
          content:
            'Use <strong>Post Analytics</strong> to see how your posts are performing, which subreddits and content are most popular, and make better decisions for future posts.',
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="profile"]',
          header: {
            title: 'Settings'
          },
          content:
            'Change your <strong>post settings</strong> here. You can change default post settings, configure notifications, and link more Reddit accounts.',
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="upgrade-account"]',
          header: {
            title: 'Postpone Plans'
          },
          content:
            "Check out <strong>Postpone's plans</strong> to schedule more posts, automate more DMs, link more accounts, and unlock features.",
          params: {
            placement: 'bottom',
            highlight: true,
            enableScrolling: false
          }
        }
      ]
    }
  },
  apollo: {
    announcements: {
      query: announcements,
      skip() {
        return !this.isLoggedIn
      }
    }
  },
  methods: {
    markdownToHTML,
    formatDate,
    announcementType(announcement) {
      if (announcement.announcementType) {
        return announcement.announcementType.toLowerCase().replace('_', '-')
      } else {
        return 'is-light'
      }
    },
    onStart() {
      this.$store.commit('startTour')
    },
    onSkip() {
      this.$store.commit('finishTour')
      this.$router.push({ name: 'dashboard' })
    },
    onFinish() {
      this.$store.commit('finishTour')
      this.$router.push({ name: 'dashboard' })
    },
    onStop() {
      this.$store.commit('finishTour')
      this.$router.push({ name: 'dashboard' })
    }
  },
  computed: {
    ...mapState(['profile']),
    ...mapGetters(['isLoggedIn', 'plan']),
    disconnectedAccounts() {
      if (!this.profile) {
        return []
      } else {
        return this.profile.redditAccounts.filter(
          (account) => !account.accountConnected
        )
      }
    },
    accountsWithoutHistoryEnabled() {
      if (!this.profile) {
        return []
      } else {
        return this.profile.redditAccounts.filter(
          (account) => !account.hasHistoryEnabled
        )
      }
    },
    prominentAnnouncements() {
      return this.announcements.filter((a) => a.prominent)
    },
    hasUnlimitedPosts() {
      if (!this.profile) {
        return false
      } else {
        return (
          this.profile.account.allowedMonthlyPosts == MAGIC_UNLIMITED_NUMBER
        )
      }
    },
    shouldShowUpgradePlan() {
      if (!this.profile) {
        return false
      }
      return (
        this.plan.monthlyPrice === 0.0 ||
        this.$store.getters.monthlyPostUsagePercentage >= 0.8 ||
        this.$store.getters.monthlyDMUsagePercentage >= 0.8
      )
    }
  }
}
